import {PROGRAM_NAMES_ENUM} from "src/constants/workflow-instance";

export const PROGRAM_BUSINESS_NAME: Record<PROGRAM_NAMES_ENUM, string> = {
    [PROGRAM_NAMES_ENUM.ACBP]: "COBB(SDO)",
    [PROGRAM_NAMES_ENUM.OTS]: "EBHS(OTS)",
    [PROGRAM_NAMES_ENUM.TEST]: "TEST",
    [PROGRAM_NAMES_ENUM.SIC]: "EBHS(SIC)",
    [PROGRAM_NAMES_ENUM.DC]: "EBHS(DC)",
    [PROGRAM_NAMES_ENUM.BIC]: "EBHS(BIC)",
    [PROGRAM_NAMES_ENUM.BrandLifecycle]: "BrandLifecycle",
    [PROGRAM_NAMES_ENUM.BrandSegmentation]: "BrandSegmentation",
    [PROGRAM_NAMES_ENUM.SelectionGapManagement]: "Selection Gap Management",
    [PROGRAM_NAMES_ENUM.DTP]: "COBB(DTP)",
    [PROGRAM_NAMES_ENUM.EstimatedParity]: "Estimated Parity",
    [PROGRAM_NAMES_ENUM.WebsiteInsights]: "Website Insights",
    [PROGRAM_NAMES_ENUM.IntegTest]: "IntegTest",
    [PROGRAM_NAMES_ENUM.StressTest]: "StressTest",
    [PROGRAM_NAMES_ENUM.ProductCompatibilityProgram]: "PCP",
    [PROGRAM_NAMES_ENUM.UMS]: "UMS",
    [PROGRAM_NAMES_ENUM.Matching]: "Matching",
    [PROGRAM_NAMES_ENUM.SACE_SCI]: "EBHS(SCI)",
    [PROGRAM_NAMES_ENUM.BrandClassifier]: "BrandClassifier",
    [PROGRAM_NAMES_ENUM.GEM]: "GEM",
    [PROGRAM_NAMES_ENUM.DataStageIntegrationTest]: "DataStageIntegrationTest",
    [PROGRAM_NAMES_ENUM.BrandArtefactEnrichment]: "BrandArtefactEnrichment",
    [PROGRAM_NAMES_ENUM.BrandDiscoveryAndEnrichment]: "BrandDiscoveryAndEnrichment",
    [PROGRAM_NAMES_ENUM.SCI]: "SCI",
    [PROGRAM_NAMES_ENUM.SCIAudit]: "SCIAudit",
    [PROGRAM_NAMES_ENUM.AuditBatch]: "AuditBatch",
    [PROGRAM_NAMES_ENUM.TestAppConfig]: "TestAppConfig",
    [PROGRAM_NAMES_ENUM.UBCSnapshotConsumption]: "UBCSnapshotConsumption",
    [PROGRAM_NAMES_ENUM.SFASINEnrichment]: "SF_ASIN_Enrichment",
    [PROGRAM_NAMES_ENUM.OASIS]: "OASIS",
    [PROGRAM_NAMES_ENUM.SACE_SCI_3P]: "EBHS(SCI)-3P",
    [PROGRAM_NAMES_ENUM.EBHSDigitization]: "EBHSDigitization",
    [PROGRAM_NAMES_ENUM.EDRI_Starfish]: "EDRI_Starfish",
    [PROGRAM_NAMES_ENUM.Starfish]: "Starfish",
    [PROGRAM_NAMES_ENUM.Starfish_Touchless]: "Starfish_Touchless",
    [PROGRAM_NAMES_ENUM.Retailer_QS]: "Retailer_QS",
    [PROGRAM_NAMES_ENUM.DataQuality]: "DataQuality",
    [PROGRAM_NAMES_ENUM.EmBHSDigitization]: "EmBHSDigitization",
    [PROGRAM_NAMES_ENUM.BrandEnrichment]: "BrandEnrichment",
    [PROGRAM_NAMES_ENUM.Dawn]: "Dawn",
    [PROGRAM_NAMES_ENUM.Zuma]: "Zuma",
    [PROGRAM_NAMES_ENUM.OrcaIntegTestProgramNDB]: "OrcaIntegTestProgramNDB",
    [PROGRAM_NAMES_ENUM.Test]: "Test",
    [PROGRAM_NAMES_ENUM.Certification]: "Certification",
    [PROGRAM_NAMES_ENUM.WESIngestion]: "WESIngestion",
    [PROGRAM_NAMES_ENUM.StructuredDataIngestion]: "StructuredDataIngestion",
    [PROGRAM_NAMES_ENUM.QUBrandIngestion]: "QUBrandIngestion",
    [PROGRAM_NAMES_ENUM.Retailers]: "Retailers",
    [PROGRAM_NAMES_ENUM.CMS]: "CMS",
    [PROGRAM_NAMES_ENUM.SourceProvisioner]: "SourceProvisioner",
    [PROGRAM_NAMES_ENUM.WebsiteCompletenessMetrics]: "WebsiteCompletenessMetrics"
}

export const PROGRAM_PAGE_ZERO_VISIBILITY: Record<PROGRAM_NAMES_ENUM, boolean> = {
    [PROGRAM_NAMES_ENUM.ACBP]: true,
    [PROGRAM_NAMES_ENUM.OTS]: true,
    [PROGRAM_NAMES_ENUM.TEST]: false,
    [PROGRAM_NAMES_ENUM.SIC]: true,
    [PROGRAM_NAMES_ENUM.DC]: true,
    [PROGRAM_NAMES_ENUM.BIC]: true,
    [PROGRAM_NAMES_ENUM.BrandLifecycle]: true,
    [PROGRAM_NAMES_ENUM.BrandSegmentation]: false,
    [PROGRAM_NAMES_ENUM.SelectionGapManagement]: true,
    [PROGRAM_NAMES_ENUM.DTP]: true,
    [PROGRAM_NAMES_ENUM.EstimatedParity]: true,
    [PROGRAM_NAMES_ENUM.WebsiteInsights]: true,
    [PROGRAM_NAMES_ENUM.IntegTest]: false,
    [PROGRAM_NAMES_ENUM.ProductCompatibilityProgram]: true,
    [PROGRAM_NAMES_ENUM.UMS]: false,
    [PROGRAM_NAMES_ENUM.Matching]: false,
    [PROGRAM_NAMES_ENUM.SACE_SCI]: true,
    [PROGRAM_NAMES_ENUM.BrandClassifier]: false,
    [PROGRAM_NAMES_ENUM.GEM]: false,
    [PROGRAM_NAMES_ENUM.DataStageIntegrationTest]: false,
    [PROGRAM_NAMES_ENUM.BrandArtefactEnrichment]: false,
    [PROGRAM_NAMES_ENUM.BrandDiscoveryAndEnrichment]: false,
    [PROGRAM_NAMES_ENUM.SCI]: true,
    [PROGRAM_NAMES_ENUM.SCIAudit]: false,
    [PROGRAM_NAMES_ENUM.AuditBatch]: false,
    [PROGRAM_NAMES_ENUM.TestAppConfig]: false,
    [PROGRAM_NAMES_ENUM.UBCSnapshotConsumption]: false,
    [PROGRAM_NAMES_ENUM.SFASINEnrichment]: true,
    [PROGRAM_NAMES_ENUM.OASIS]: true,
    [PROGRAM_NAMES_ENUM.SACE_SCI_3P]: true,
    [PROGRAM_NAMES_ENUM.EBHSDigitization]: true,
    [PROGRAM_NAMES_ENUM.StressTest]: false,
    [PROGRAM_NAMES_ENUM.EDRI_Starfish]: true,
    [PROGRAM_NAMES_ENUM.Starfish]: true,
    [PROGRAM_NAMES_ENUM.Starfish_Touchless]: true,
    [PROGRAM_NAMES_ENUM.Retailer_QS]: true,
    [PROGRAM_NAMES_ENUM.DataQuality]: true,
    [PROGRAM_NAMES_ENUM.EmBHSDigitization]: true,
    [PROGRAM_NAMES_ENUM.Dawn]: true,
    [PROGRAM_NAMES_ENUM.Zuma]: true,
    [PROGRAM_NAMES_ENUM.BrandEnrichment]: true,
    [PROGRAM_NAMES_ENUM.OrcaIntegTestProgramNDB]: true,
    [PROGRAM_NAMES_ENUM.Test]: false,
    [PROGRAM_NAMES_ENUM.Certification]: true,
    [PROGRAM_NAMES_ENUM.WESIngestion]: true,
    [PROGRAM_NAMES_ENUM.StructuredDataIngestion]: true,
    [PROGRAM_NAMES_ENUM.QUBrandIngestion]: true,
    [PROGRAM_NAMES_ENUM.Retailers]: true,
    [PROGRAM_NAMES_ENUM.CMS]: true,
    [PROGRAM_NAMES_ENUM.SourceProvisioner]: true,
    [PROGRAM_NAMES_ENUM.WebsiteCompletenessMetrics]: true
}

export const EXCLUDE_CYCLE_TIME_DATA_FOR_PROGRAMS = [PROGRAM_NAMES_ENUM.SIC, PROGRAM_NAMES_ENUM.DC, PROGRAM_NAMES_ENUM.BIC]

export enum PRODUCT_NAMES_ENUM {
    SelectionDiscovery = 'Selection Discovery',
    BrandArtefactEnrichment = 'Brand Artefact Enrichment',
    BrandDiscoveryAndEnrichment = "Brand Discovery and Enrichment",
    AlexaProcessor = "Alexa Processor",
    Matching = "Matching",
    EDRI = "EDRI",
    SCI = "SCI",
    OASIS = "OASIS",
    SelectionAdditionAndBrandEnrichment ="Selection Addition and Brand Enrichment",
    BrandLifecycle = "Brand Lifecycle",
    SelectionGapManagement = "Selection Gap Management",
    UniversalMappingStore = "Universal Mapping Store",
    BrandClassifier = "Brand Classifier",
    SCIAudit = "SCI Audit",
    BrandEnrichment = "Brand Enrichment",
    UBCSnapshotConsumption = "UBC Snapshot Consumption",
    AuditBatch = "Audit Batch",
    GEM = "GEM"
}

// Todo: This is temporarily introduced till we have capability registry for validation
export const EXCLUDE_DATA_FOR_PRODUCT_KEYS = [PRODUCT_NAMES_ENUM.GEM, PRODUCT_NAMES_ENUM.SelectionGapManagement]